import { FaceTecSDK } from "../../../core-sdk/FaceTecSDK.js/FaceTecSDK";
import { NetworkingRequest } from "../utilities/NetworkingRequest";
var LivenessCheckProcessor = /** @class */ (function () {
    function LivenessCheckProcessor(faceTecSDKInstance, sampleAppControllerReference) {
        var _this = this;
        this.latestServerResult = null;
        this.latestServerResultRaw = null;
        this.latestFaceTecResult = null;
        this.onSessionRequest = function (sessionRequestBlob, sessionRequestCallback) {
            NetworkingRequest.send(sessionRequestBlob, sessionRequestCallback, {
                onSuccess: function (responseJSON) {
                    var _a, _b, _c;
                    _this.latestServerResultRaw = (_b = (_a = responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.result) !== null && _a !== void 0 ? _a : responseJSON) !== null && _b !== void 0 ? _b : null;
                    _this.latestServerResult = (_c = responseJSON === null || responseJSON === void 0 ? void 0 : responseJSON.result) !== null && _c !== void 0 ? _c : null;
                },
            });
        };
        this.onFaceTecExit = function (faceTecSessionResult) {
            var _a, _b, _c, _d, _e, _f, _g, _h;
            _this.latestFaceTecResult = faceTecSessionResult;
            var sessionStatus = (_a = faceTecSessionResult === null || faceTecSessionResult === void 0 ? void 0 : faceTecSessionResult.status) !== null && _a !== void 0 ? _a : null;
            var successful = sessionStatus === FaceTecSDK.FaceTecSessionStatus.SessionCompleted;
            var auditTrail = [];
            var sessionId = (_c = (_b = _this.latestServerResult) === null || _b === void 0 ? void 0 : _b.sessionId) !== null && _c !== void 0 ? _c : "";
            if (Array.isArray((_d = _this.latestServerResult) === null || _d === void 0 ? void 0 : _d.auditTrail)) {
                auditTrail.push.apply(auditTrail, ((_f = (_e = _this.latestServerResult) === null || _e === void 0 ? void 0 : _e.auditTrail) !== null && _f !== void 0 ? _f : []));
            }
            else if ((_g = _this.latestServerResult) === null || _g === void 0 ? void 0 : _g.auditTrailImage) {
                auditTrail.push(_this.latestServerResult.auditTrailImage);
            }
            var livenessProven = Boolean((_h = _this.latestServerResult) === null || _h === void 0 ? void 0 : _h.livenessProven);
            _this.controller.onComplete({
                sessionStatus: sessionStatus,
                successful: successful,
                livenessProven: livenessProven,
                auditTrail: auditTrail,
                sessionId: sessionId,
                rawServerResult: _this.latestServerResultRaw,
            });
        };
        this.controller = sampleAppControllerReference;
        faceTecSDKInstance.start3DLiveness(this);
    }
    return LivenessCheckProcessor;
}());
export { LivenessCheckProcessor };
